import { Form, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Global } from 'src/app/Global';
import { Router } from '@angular/router';
// import { CommonService } from 'src/app/shared/common.service';
import { DataService } from 'src/app/Common/data.service';
import { CommonService } from 'src/app/shared/common.service';
// import { HttpErrorResponse } from '@angular/common/http';
import { HTTPStatus, AppTokenHandler, UserInfo } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import saveAs from 'file-saver';

@Component({
  selector: 'app-view-upload',
  templateUrl: './view-upload.component.html',
  styleUrls: ['./view-upload.component.scss']
})
export class ViewUploadComponent implements OnInit {
  ViewUploadForm: UntypedFormGroup;
  ViewUploadDatasource: any;
  viewdata: any;
  IsLoadingResults = false;
  data: [];
  pageEvent: PageEvent;
  Ispanelshow: any;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  // displayedColumns = ['AssignmentGroupName', 'EmpName', 'UploadDate'
  // ];

  displayedColumns = ['AssignmentGroupName', 'EmpName', 'UploadDate'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(
    public _global: Global,
    private _router: Router,
    public pcommonService: CommonService,
    public _dataservice: DataService,
    private status: HTTPStatus,
    private error: AppErrorHandler,
    private _formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit() {

    this.Ispanelshow = false;
    this.ViewUploadForm = this._formBuilder.group({

      AssignmentGroupName: [],
      EmpName: [],
      UploadDate: [],
      UploadFromDate: [],
      UploadToDate: [],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
      FromDate: [],
      ToDate: [],
    });
    this._global.length = 0;
    this._global.pageIndex = 0;
    this._global.totalPage = 0;
    this.GetAssignmentUploadDetails();
  }


  GetAssignmentUploadDetails() {
    this.IsLoadingResults = true;
    debugger;
    this.ViewUploadForm.controls['PageNumber'].setValue(this._global.pageIndex + 1);
    this.ViewUploadForm.controls['PageSize'].setValue(this._global.RecordSize);
    this.ViewUploadForm.patchValue({
      UploadFromDate: this.ViewUploadForm.controls.FromDate.value,
      UploadToDate: this.ViewUploadForm.controls.ToDate.value,
    });
    this._dataservice.PostData('Category/GetAssigmentUploadData/', this.ViewUploadForm.value).subscribe(result => {
      this.viewdata = result;


      if (this.viewdata != null && this.viewdata.length > 0) {
        this.ViewUploadDatasource = this.viewdata;

        this._global.length = this.viewdata[0].totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
      }
      else {
        this.ViewUploadDatasource = this.viewdata;
        this._global.length = 0;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
      this.IsLoadingResults = false;

    }
    );


  }
  orgValueChange(event) {
    this.ViewUploadForm.controls.ToDate.reset();
  }

  SearchDetailsForMailStatus() {

    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this.GetAssignmentUploadDetails();

  }

  onExit() {
    if (!confirm('Are you sure want to Exit this page?')) {
      return;
    }
    //this._router.navigate(['/home'])
    window.history.back();
  }


  ExportToExcel() {
    this.status.setHttpStatus(true);
    this.pcommonService.ExportToExcelAssigmentUpload(this.ViewUploadForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'Assigment_Upload.xls');
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  reset() {

    if (confirm('Are you sure want to reset from the form.')) {
      this.ViewUploadForm.reset();
      this.SearchDetailsForMailStatus();

    }
  }
  onPaginateChange1(event) {
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
    this.GetAssignmentUploadDetails();
  }

  showhide() {
    this.Ispanelshow = !this.Ispanelshow;

  }

}
